import { router, setPageContent } from "..";
import { getSp2, putSp2 } from "../api/smartplug2s_{imei}";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { onMobile, scanBarcode } from "../mobile";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";
import { MaterialDesign } from "../view/material_design";

/**
 * @type {import("navigo").Handler}
 */
function registerSmartplug2Page(ctx) {
	const imei = Bulma.input({
		type: "text",
	});

	const name = Bulma.input({
		type: "text",
	});

	setPageContent(
		centeredBox(
			"small",
			Bulma.level(
				Bulma.levelLeft(
					Bulma.levelItem(
						Bulma.title(t.smartplug2.addDevicePage.header, "is-4"),
					),
				),
				Bulma.levelRight(
					Bulma.levelItem(
						MaterialDesign.icon({
							id: "help",
							onClick: () => window.open(t.supportUrl, "_blank"),
						}),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label("IMEI"),
				Bulma.field(
					{
						styles: onMobile ? ["has-addons"] : undefined,
					},
					Bulma.control(
						{
							styles: ["is-expanded"],
						},
						imei.element,
					),
					Bulma.control(
						{
							hidden: !onMobile,
						},
						Bulma.button(
							{
								onClick: onClickScan,
							},
							MaterialDesign.icon({
								id: "barcode",
								alignment: "right",
							}),
						),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label(t.device.addDevicePage.chooseNamePrompt),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{
					styles: ["is-grouped"],
				},
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickRegister,
							styles: ["is-primary"],
						},
						t.add,
					),
				),
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: () => router.jump("/devices/register"),
							styles: ["is-primary"],
						},
						t.back,
					),
				),
			),
		),
	);

	async function onClickRegister() {
		const attempt = errorSection.attempt(async () => {
			const user = await state.getActiveUser();

			let sp2 = await getSp2(imei.getValue());
			sp2.Metadata.Access = [user.Email];
			sp2.Metadata.Name = name.getValue();
			sp2.Metadata.OwnerEmail = user.Email;

			sp2 = await putSp2(sp2);
			state.smartplug2s[sp2.Imei] = sp2;
			router.jump(`/smartplug2/${sp2.Imei}`);
		});
		loadingScreen.waitFor(attempt);
	}

	async function onClickScan() {
		scanBarcode(t.smartplug2.addDevicePage.scanImeiQrPrompt).then(
			(code) => {
				if (!code) return;
				imei.setValue(code);
			},
		);
	}
}

export { registerSmartplug2Page };
